import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { ILoadedProducts } from "./models";

const initialState: ILoadedProducts = {};

export default function loadedProductsReducer(
  state: ILoadedProducts,
  action: Action,
): ILoadedProducts {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const { products } = (action as PayloadAction<ILoadedProducts>)
        .payload;
      return {
        ...state,
        products: {
          ...state.products,
          ...products,
        },
      };
    }
    default:
      return state;
  }
}
